import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ProjectResponseArrayModel,
  ProjectResponseModel,
  bidSubmissionModel,
} from "../../models/ProjectResponseModel";

const initialProjectResponseState: ProjectResponseArrayModel = {
  project_Response: [],
  isFetching: false,
};
const ProjectResponseSlice = createSlice({
  name: "ProjectResponse",
  initialState: initialProjectResponseState,
  reducers: {
    setAllProjectsWithStatus(
      state,
      action: PayloadAction<ProjectResponseModel[]>
    ) {
      state.project_Response = action.payload;
    },
    setProjectsWithStatusForUserId(
      state,
      action: PayloadAction<ProjectResponseModel[]>
    ) {
      state.project_Response = action.payload;
    },
    setIsFetching(state, action: PayloadAction<boolean>) {
      state.isFetching = action.payload;
    },
    setProjectBidSubmissionData(
      state,
      action: PayloadAction<bidSubmissionModel>
    ) {
      const { projectId, bidSubmissionDate, estimatedValue } = action.payload;
      const projectIndex = state.project_Response.findIndex(
        (rec) => rec.projectId === projectId
      );
      state.project_Response[projectIndex].estimatedValue = estimatedValue;
      state.project_Response[projectIndex].bidSubmissionDate =
        bidSubmissionDate;
    },
    setIsBidDropped(
      state,
      action: PayloadAction<{ id: number; status: boolean }>
    ) {
      const { id, status } = action.payload;
      const projectIndex = state.project_Response.findIndex(
        (rec) => rec.projectId === id
      );
      state.project_Response[projectIndex].isBidDropped = status;
    },
    setBidPriority(
      state,
      action: PayloadAction<{ id: number; priority: string }>
    ) {
      const { id, priority } = action.payload;
      const projectIndex = state.project_Response.findIndex(
        (rec) => rec.projectId === id
      );
      state.project_Response[projectIndex].priority = priority;
    },
  },
});
export default ProjectResponseSlice;
